import React from 'react'

import Page from '../Page'
import StatsBlock from '../../StatsBlock'

const ShortTextPanel = ({
  id,
  panelColor,
  panelTexture,
  panelLabel,
  panelLabelColor,
  entries
}) => {
  return (
    <Page.Panel noPadding color={panelColor} texture={panelTexture} key={`panel${id}`}>
      {panelLabel && (
        <Page.Panel.Label color={panelLabelColor}>
          {panelLabel}
        </Page.Panel.Label>
      )}
      <StatsBlock stats={entries} color={panelColor} />
    </Page.Panel>
  )
}

export default ShortTextPanel
